import { render, staticRenderFns } from "./Bullet.vue?vue&type=template&id=3825985f&scoped=true&"
import script from "./Bullet.vue?vue&type=script&lang=js&"
export * from "./Bullet.vue?vue&type=script&lang=js&"
import style0 from "./Bullet.vue?vue&type=style&index=0&id=3825985f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3825985f",
  null
  
)

export default component.exports